import { LOCALE } from '@hhgtech/hhg-components/types'

export enum PregnancyCategoryName {
  'First trimester',
  'Second trimester',
  'Third Trimester',
}

export const PREGNANCY_CATEGORY: Record<
  LOCALE,
  Record<Partial<PregnancyCategoryName | number>, string>
> = {
  [LOCALE.Vietnam]: {
    // START TRIM MARKER vi-VN
    [PregnancyCategoryName['First trimester']]:
      '/mang-thai/thai-ky/tam-ca-nguyet-1',
    [PregnancyCategoryName['Second trimester']]:
      '/mang-thai/thai-ky/tam-ca-nguyet-2',
    [PregnancyCategoryName['Third Trimester']]:
      '/mang-thai/thai-ky/tam-ca-nguyet-3',
    // END TRIM MARKER vi-VN
  },
  [LOCALE.Cambodia]: {
    
  },
  [LOCALE.Indonesia]: {
    
  },
  [LOCALE.Malaysia]: {
    
  },
  [LOCALE.Myanmar]: {
    
  },
  [LOCALE.PhilippinesEnglish]: {
    
  },
  [LOCALE.PhilippinesTagalog]: {
    
  },
  [LOCALE.Taiwan]: {
    
  },
  [LOCALE.Singapore]: {
    
  },
  [LOCALE.Thailand]: {
    
  },
  [LOCALE.India]: {
    
  },
}

export const DATE_FORMAT_BY_LOCALE: Record<LOCALE, string> = {
  [LOCALE.Vietnam]: 'DD MMMM, YYYY',
  [LOCALE.Cambodia]: 'MMMM DD, YYYY',
  [LOCALE.Indonesia]: 'MMMM DD, YYYY',
  [LOCALE.Malaysia]: 'MMMM DD, YYYY',
  [LOCALE.Myanmar]: 'MMMM DD, YYYY',
  [LOCALE.PhilippinesEnglish]: 'MMMM DD, YYYY',
  [LOCALE.PhilippinesTagalog]: 'MMMM DD, YYYY',
  [LOCALE.Taiwan]: 'MMM D日, YYYY', // https://hhgdev.atlassian.net/browse/HHD-6480
  [LOCALE.Singapore]: 'MMMM DD, YYYY',
  [LOCALE.Thailand]: 'MMMM DD, YYYY',
  [LOCALE.India]: 'MMMM DD, YYYY',
}
